import React from "react";
import { Box, Typography, IconButton, CircularProgress } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import { ReactComponent as CSVIcon } from "./../../../assets/icons/csvIcon.svg";

export const FilePreviewCard = ({
  fileName = "",
  fileSize = "10000",
  status = "Uploading...",
  progress = 0,
  onDelete,
  showDeleteIcon = true,
}) => {
  const formatFileSize = (bytes) => {
    if (!bytes) return "0 Bytes";

    const sizes = ["Bytes", "Kb", "Mb", "Gb", "Tb"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));

    const value = bytes / Math.pow(1024, i);

    return `${value.toFixed(0)}${sizes[i]}`;
  };
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      border="1px solid #e0e0e0"
      borderRadius="8px"
      p={2}
      mb={1}
      sx={{
        backgroundColor: "#fff",
      }}
    >
      {/* Left: File Icon + Info */}
      <Box display="flex" alignItems="center" gap={2}>
        {fileName.includes(".csv") ? (
          <CSVIcon sx={{ fontSize: 32 }} />
        ) : (
          <UploadFileIcon sx={{ fontSize: 32, color: "primary.main" }} />
        )}
        <Box>
          <Typography variant="body1" fontWeight={500}>
            {fileName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {formatFileSize(fileSize)} • {status}
          </Typography>
        </Box>
      </Box>

      {/* Right: Actions */}
      <Box display="flex" alignItems="center" gap={2}>
        {showDeleteIcon && (
          <IconButton onClick={onDelete} size="small">
            <DeleteIcon />
          </IconButton>
        )}

        <Box position="relative" display="inline-flex">
          <CircularProgress
            variant={progress === 0 ? "indeterminate" : "determinate"}
            value={progress}
            size={36}
            thickness={4}
            sx={{ color: "primary.main" }}
          />
          {progress > 0 && (
            <Box
              top={0}
              left={0}
              bottom={0}
              right={0}
              position="absolute"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Typography
                sx={{ fontSize: "10px" }}
                variant="caption"
                component="div"
                color="text.secondary"
              >
                {`${progress}%`}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
